const Buttons = () => {
    return ( 
        <button className="btn1">
            Request invite
        </button>
     );
}
 
export default Buttons;